import React from 'react';
import { Button } from '@/components/ui/button';

const FIELDS = [['status', 'Statut'], ['tour_type', 'Prestation'], ['start_time', 'Horaire'], ['loading_time', 'Chargement'], ['comment', 'Commentaire']];
const LABELS = { prevu: 'Prévu', present: 'Présent', absent: 'Absent', repos: 'Repos', repos_force: 'Repos forcé',
  repos_demande: 'Repos demandé', disponible: 'Disponible', cp: 'Congé payé', am: 'Arrêt maladie', en_cours_integration: "En cours d'intégration" };
const fmt = (v) => (v === null || v === undefined || v === '' ? '—' : LABELS[v] || String(v));

const ConflictRow = ({ item, name, onKeepMine, onTakeServer }) => {
  const { date, userId, cell } = item;
  const server = cell._server || {};
  const at = server.updated_at ? new Date(server.updated_at).toLocaleString('fr-FR') : 'date inconnue';
  return (
    <div className="rounded border border-red-200 bg-white p-3" data-testid={`planning-conflict-${userId}-${date}`}>
      <p className="text-sm font-semibold">{name} — {new Date(`${date}T12:00:00`).toLocaleDateString('fr-FR')}</p>
      <p className="text-xs text-slate-500">Modifié par {server.updated_by_name || 'un autre utilisateur'} le {at}</p>
      <div className="mt-2 grid grid-cols-3 gap-x-3 text-xs">
        <span className="font-semibold text-slate-500">Champ</span>
        <span className="font-semibold text-amber-700">Ma saisie</span>
        <span className="font-semibold text-slate-700">Version serveur</span>
        {FIELDS.map(([k, l]) => (
          <React.Fragment key={k}>
            <span>{l}</span>
            <span className={fmt(cell[k]) !== fmt(server[k]) ? 'font-semibold text-amber-800' : ''}>{fmt(cell[k])}</span>
            <span>{fmt(server[k])}</span>
          </React.Fragment>
        ))}
      </div>
      <div className="mt-2 flex gap-2">
        <Button size="sm" variant="outline" onClick={() => onTakeServer(item)} data-testid={`planning-conflict-take-server-${userId}-${date}`}>Prendre la version serveur</Button>
        <Button size="sm" onClick={() => onKeepMine(item)} data-testid={`planning-conflict-keep-mine-${userId}-${date}`}>Garder ma saisie</Button>
      </div>
    </div>
  );
};

export const PlanningConflictsPanel = ({ conflicts, employees, onKeepMine, onTakeServer }) => {
  if (!conflicts.length) return null;
  const nameOf = (id) => employees.find((e) => e.user_id === id)?.name || id;
  return (
    <div className="mb-4 rounded-lg border-2 border-red-300 bg-red-50 p-4" data-testid="planning-conflicts-panel">
      <p className="font-semibold text-red-900">Un autre manager a modifié ces journées pendant votre saisie</p>
      <p className="mb-3 text-sm text-red-800">Rien n’a été écrasé. Choisissez pour chaque journée la version à conserver ; « Garder ma saisie » reste à enregistrer.</p>
      <div className="grid gap-3 md:grid-cols-2">
        {conflicts.map((item) => (
          <ConflictRow key={`${item.userId}|${item.date}`} item={item} name={nameOf(item.userId)} onKeepMine={onKeepMine} onTakeServer={onTakeServer} />
        ))}
      </div>
    </div>
  );
};
